<a [routerLink]="['/profile']" class="dropdown-item">{{ 'navbar.profile' | translate }}</a>
<a *ngIf="isTester" [routerLink]="['/tester']" class="dropdown-item">{{ 'navbar.tester' | translate }}</a>
<div class="dropdown-divider"></div>
<a (click)="logout()" class="dropdown-item" href="javascript:void(0)">{{ 'navbar.logout' | translate }}</a>
